import taskInstancesFiltersUrl from './taskInstancesFilters.html';

class TaskInstancesFiltersCtrl {
  isGroupFilterEnabled = false; // Filter by group is rescheduled for v2

  constructor(PersonaCollection, ShiftTasksService, ShiftUtils) {
    'ngInject';

    Object.assign(this, { PersonaCollection, ShiftTasksService, ShiftUtils });
  }

  $onInit() {
    this.groupsForFilter = this.ShiftUtils.getGroupsFilterOptions(
      this.ShiftTasksService.userGroups
    );
  }

  toggleFilter(...args) {
    this.ShiftTasksService.toggleFilter(...args);
  }

  shouldHideFilter(options) {
    return !options || options.length < 2;
  }
}

export default {
  templateUrl: taskInstancesFiltersUrl,
  controller: TaskInstancesFiltersCtrl,
  controllerAs: 'ctrl',
};
